module.exports = __webpack_public_path__ + "static/bridgeMusic-0c250b63ae9c4cf7c35fc44685e87e2a.jpg";